<template>
    <td v-for="(quartile, index) in quartiles" :key="`quart_${index}`" class="los-score-quartile">
        <span :class="{ outlined: score >= quartile.begin && score <= quartile.end }">
            <template v-if="quartile.begin === quartile.end">{{ quartile.begin }}</template>
            <template v-else>{{ quartile.begin }} - {{ quartile.end }}</template>
        </span>
    </td>
</template>
<script src="./LosScore.ts"></script>
